
<!-- start of Quick search filter -->
<div class="col-lg-12 nopadding">
  <app-quick-search [DefaultFilterArray]="compReviewServiceService.DefaultFilterArray" [QuickSearchFilterArray]="quickFilterArray"
    [FilterFieldDefaultValues]="filterFieldDefaultValues" (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)"></app-quick-search>
</div>
<!-- end of Quick search filter -->

<div class="col-md-12 nopadding">
  <div class="col-lg-8 d-flex align-item-center nopadding">
    <!--Filter Code  -->
    <div class="col-lg-12 nopadding">
      <app-filter-panel [pageName]="compReviewServiceService.pageName" [GridColumns]="GridColumns"
        [DefaultFilterArray]="compReviewServiceService.DefaultFilterArray"
        [isAddFilter]='true'
        (FilterEvent)="FilterApplyFilterEvent($event)"
        (FilterEventClearGroupName)="FilterEventClearGroupName($event)"
        (FilterEventCompReportReload)="FilterEventCompReportReload($event)"
        [pageName]="'Comparative-Review-Report'">
      </app-filter-panel>
    </div>
  </div>


  <!-- Comments -->
  <div class="col-lg-4 pd-t-4 nopadding">
       <ng-container>
      <label for="browseCommentLabel" id="browseCommentLabel" class="floatRight commentbtnWrapper">
        <p-button id="commentBtn" type="button" class="commentBtn" 
        [ngClass]="'button btn-xs non-active-symbol'" 
        (onClick)="onBrowsecomCommentViewer()">
          Browse Review Comments
        </p-button>
         <span class="btnBadge">{{this.commentViewerService.browseCommentViewerTotalCount}}</span>
      </label>        
    </ng-container>
    <ng-container>
     <app-comp-review-schedule-report [sampleListData]="sampleDrpListData" class="floatRight">
    </app-comp-review-schedule-report>
    </ng-container>

  </div>
  <!-- End of Comments -->

</div>


<!-- Filter Quick Fields Panel Code -->
<div class="col-lg-12 nopadding">
  @if(isLoadingRecords) {
  <div class="example-loading-shade"></div>
  }
    <app-symbol-panel 
    [GroupNameArray]="GroupNameList" 
    [SampleNameArray]="this.compReviewServiceService.applicationFilters"
    (ActiveQuickFilterGroupName)="setActiveQuickFilterGroupName($event)"
    (ActiveQuickFilterEventType)="FilterApplyFilterEvent($event)"
    (RemoveCustomSampleFilterQuery)="RemoveCustomSampleFilterQuery($event)">
    </app-symbol-panel>
</div>

<div class="col-lg-12 nopadding">
  @if(isLoadingRecords) {
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  <p-contextMenu #cm [model]="contexMenuItems" />
  <p-treeTable #tt id="compreview-tree-datatable" [value]="MatchedReportTreeViewData" [columns]="cols"
     selectionMode="single" 
    [(selection)]=selectedNodes
    (onNodeCollapse)="onNodeCollapse($event)" 
    (onNodeExpand)="onNodeExpand($event)" 
    (onNodeSelect)="nodeSelect($event)" 
    [metaKeySelection]="metaKeySelection" 
    scrollHeight="flex"
    [virtualScroll]="true"
    [resizableColumns]="true" 
    [scrollable]="false" 
    [first]="firstRecordIndex"
    scrollHeight="40vh" 
    sortMode="multiple" 
    [paginator]="true" appendTo="body"
    alwaysShowPaginator="true" paginatorPosition="both" [resizableColumns]="true"
    [rows]="constantService.DEFAULT_ROWSIZE" [rowsPerPageOptions]=constantService.DEFAULT_ROWSPERPAGEOPTION
    [pageLinks]=constantService.DEFAULT_PAGELINKS  [lazy]="false" showGridlines 
    [totalRecords]="totalRecords" styleClass="comp-report-review" columnResizeMode="expand" scrollHeight="50vh"
    styleClass="comparative-review-table">
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{isLoadingRecords?constantService.LOADIND_DATA_MSG:constantService.NO_RECORDFOUND_MSG}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of cols; track col.label; let i = $index){
        <th [id]="col.header" [ttSortableColumn]="col.field" ttResizableColumn>
          <span> {{col.header}}</span>
          <p-treeTableSortIcon [field]="col.field" />
        </th>}
      </tr>
      <tr>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-row="rowData" let-columns="columns" let-rowIndex="rowIndex">
      <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode"  [ttContextMenuRow]="rowNode" [ngClass]="{'main-parent-row': rowNode.node.expanded && row.parent=='Y' ,'sample-row':'SAMPLE'.includes(row['status']),'sample-parent': 'PARENT,REPORT'.includes(row['status']),'sample-child':'CHILD'.includes(row['status'])}">
        @for(col of columns;track col.field; let columnIndex = $index;) {
        <td class="ui-resizable-column" [ngClass]="{ 'main-parent-row': rowNode.node.expanded && row.parent=='Y','sample-row':'SAMPLE'.includes(row['status']),'sample-parent':'PARENT,REPORT'.includes(row['status']),'sample-child':'CHILD'.includes(row['status']) }">
          @if(columnIndex===0 && ((row['type'] && row['type'].length>=4) || 'SAMPLE,SAMPLENAME,REPORT'.includes(row['recordType']))){
          <p-treeTableToggler [rowNode]="rowNode" />
          }
          @if(col.header ==='Action'){
          <span>
            @if((row['type'] && row['type'].length>=4) || 'SAMPLENAME,REPORT'.includes(row['recordType'])){
              @if(('REPORT,SAMPLE,CHILD'.includes(row['recordType']))){
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
              (onClick)="onView(row,rowNode,rowIndex);"></p-button>
            <p-button class="pi pi-xxx treeViewTcon" or class="fa fa-xxx treeViewTcon"
              matTooltip="Parent/Child Event Tree" [matTooltipShowDelay]="1000" matTooltipPosition="above"
              appendTo="body" icon="fa fa-fw fa-tree" [id]="'tree'+ rowIndex" (onClick)="onEventTree(row,rowNode);">
            </p-button>
          }
            @if(('REPORT,CHILD'.includes(row['recordType']) || 'Y'.includes(row['parent']))){
            <p-button class="pi pi-xxx commentIcon" or class="fa fa-xxx commentIcon" [ngClass]="(this.commentViewerService.commentIds.indexOf(row['id'])>=0) || ((columnIndex===0 && ('SAMPLE,SAMPLENAME,REPORT'.includes(row['recordType']))) && this.commentViewerService.commentIds.indexOf(row['sampleName'])>=0 && this.commentViewerService.commentIds.indexOf(row['orderID'])>=0) ? 'commentIconGreen' :''" matTooltip="Add Comment"
              [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-comment"
              [id]="'comment'+ rowIndex" (onClick)="onComment(row,rowNode)">
            </p-button>
            }
            @if(!('SAMPLE,CHILD'.includes(row['recordType']) || 'Y'.includes(row['parent']))){
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-trash" (onClick)="onDelete(row,rowNode,rowIndex);"
              >
            </p-button>
            <p-button class="pi pi-xxx commentIcon" or class="fa fa-xxx commentIcon" [ngClass]="this.commentViewerService.commentIds.indexOf(row['sampleName'])>=0 ? 'commentIconGreen' :''" matTooltip="Add Comment"
            [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-comment"
            [id]="'comment'+ rowIndex" (onClick)="onComment(row,rowNode)">
            </p-button>
            }
            @if(row['invalidFields'] && row['invalidFields'].length>0){
              <span> <i class="fa fa-asterisk" style="font-size:8px;"></i> </span>
            }
            }
          </span>
          }
          <!-- set String -->
          @if((col.header | lowercase) !=='orderid' && (col.header | lowercase)!=='status' && (col.header | lowercase) !== 'comment'){
          <span>
          @if((row['invalidFields'] && row['invalidFields'].indexOf(col.field)>=0)){
            <span style="background-color: yellow;"><span><i class="fa fa-asterisk" style="font-size:8px;"></i></span>{{row[col.field]}}</span>
          } @else {
            {{row[col.field]}}
          }           
          </span>
          }
          @if(col.header ==='OrderID'){
          <span>
            <a class="ordertID-able-link" matTooltip="View Order Details" [matTooltipShowDelay]="1000" appendTo="body"
              [id]="'OrderID'+ rowIndex" (click)="onShowOrderViewer(row,rowNode,rowIndex);"
              style="cursor: pointer">{{row[col.field]}}</a>
          </span>
          }
          @if(col.header === 'Comment'){
          <span tooltipStyleClass="custom-tooltip" [escape]="false" [pTooltip]="getTooltipContent(row,rowNode)">
            {{row[col.field]}}
          </span>
          }
        </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <p-button type="button" id="tree-expand-collapse" [label]="expandCollapseAll"
        (onClick)="exapandORcollapse(MatchedReportTreeViewData)">
      </p-button>
      <app-export-to-csv [gridColumns]="GridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
      Total Records: {{MatchedReportTreeViewData.length == 0? 0 : totalRecords}}
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      Showing {{MatchedReportTreeViewData.length == 0? 0 : startLimit + 1}} to {{MatchedReportTreeViewData.length
      < rowcount ? MatchedReportTreeViewData.length < startLimit ? endLimit : MatchedReportTreeViewData.length :
        endLimit}} entries </ng-template>
  </p-treeTable>

</div>

<!-- below code to make common edit screen -->
@if(isDisplayViewDialog){
<app-comp-review-view-details [screenType]="'rowViewer'" (closeDialog)="closeAllDialogs($event)"
  [rowData]="selectedRow[0]" [index]="rowIndexForViewDialog" value='View'>
</app-comp-review-view-details>}

@if(isDisplayEventTreeDialog){
<app-event-tree-dialog id="comp-sample-child-event-tree" [SelectedRow]="selectedRow"
  [isTreeOpen]="isDisplayEventTreeDialog" [pageName]="compReviewServiceService.pageName" (closeDialog)="closeAllDialogs($event)">
</app-event-tree-dialog>
}

@if(isDisplayCommentDialog){
<app-comment-viewer 
  [pageName]="compReviewServiceService.pageName" 
  [isOpenCommentViewer]="isDisplayCommentDialog"
  [isDisplayAddCommentForm]="isDisplayAddCommentForm"
  [isDisplayDateRangeFilter]="false"
  [gridColumnsJSON]="queryCommentGridColumns" [selectedRow]="selectedRow"
  [commentStaticFilters]="commentStaticFilters" [commentAPIDetail]="commentAPIDetail"
  (closeCommentDialog)="closeAllDialogs('false');this.getBrowseCommentViewerCount()">
</app-comment-viewer> }